import CandidaturesService from "@services/candidatures-home-service";
import { initialiseComponents } from "../../core";
import Component from "../component.abstract";

interface CandidaturesProps {
    url: string
}

export default class Candidatures extends Component {
  private url: string;
  private service: CandidaturesService;
  public data: any;
  constructor(private props: CandidaturesProps, element: HTMLElement) {
    super(props, element);
    this.url = props.url;
  }

  mounted(): void {
    if (this.url) {
      this.call(this.url);
    }
  }
  
  call(url: string): void {
    this.service = new CandidaturesService(url);
    this.service.post({}, this.handleResponse.bind(this));
    this.service.setErrorHandler((error: any) => {
       document.querySelector(".candidatures").classList.add("hide");
       this.data = error;
    });
  }

  handleResponse(response: any): void {
    this.data = response;
    const idx = 0;
    if (response.trackingsClick?.length > 0) {
      document
        .querySelector(".candidatures .asSubmit")
        .setAttribute("data-track", JSON.stringify(response.trackingsClick[0]));
    }
    if (response.trackingsLoad?.length > 0) {
      const eventtracking = response.trackingsLoad[0];
      eventtracking.trigger = "init";
      this.element.setAttribute("data-track", JSON.stringify(eventtracking));
    }

    const lazys = document.querySelectorAll(
      "ul[data-candidatures-home]>li.lazy"
    );
    for (let i = 0; i < response.items.length && i < lazys.length; i++) {
      const offer = document.createElement("li");
      offer.setAttribute("class", "hide");
      const dt = '{"candidature" : "candidature", "idx" : ' + (idx + i) + "}";
      offer.setAttribute("data-candidatures-item", dt);
      this.element.appendChild(offer);
    }
    initialiseComponents();
    PubSub.publish("candidatures.loaded", this);
    if (this.element.className.indexOf("global-lazy-loading") >= 0) {
      // Wait for the other lazy components before displaying the results
      this.element.addEventListener("display", () => {
          this.displayResults(response)
      });
      this.element.dispatchEvent(new CustomEvent("ready"));
    } else {
      // Just display the results
      this.displayResults(response);
    }
  }
  displayResults(response: any):void {
       const lazys = document.querySelectorAll(
         "ul[data-candidatures-home]>li.lazy"
       );
       const hides = document.querySelectorAll(
         "ul[data-candidatures-home]>li.hide:not(.lazy)"
       );
       for (let i = 0; i < lazys.length; i++) {
         lazys[i].classList.add("hide");
         if (hides[i]) {
           hides[i].classList.remove("hide");
         }
       }

       if (response.items.length) {
         document
           .querySelector(".candidatures .asSubmit")
           .classList.remove("hide");
       } else {
         document
           .querySelector("ul[data-candidatures-home]+span")
           .classList.remove("hide");
       }

       document
         .querySelector("section.candidatures .header.lazy-loading")
         .classList.remove("lazy-loading");

       PubSub.publish("candidatures.loaded", this);
  }
}
